// @ts-nocheck
import {
    chain,
    DispatchClearMessages,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/ClearMessages";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const ClearCheckoutPlaceOrderErrorMessages = createChainHandler(
    "ClearCheckoutReviewAndSubmitPlaceOrderErrorMessage",
    chain,
    props => {
        const state = props.getState();

        if (state?.pages?.checkoutReviewAndSubmit?.placeOrderErrorMessage) {
            props.dispatch({
                type: "Pages/CheckoutReviewAndSubmit/SetPlaceOrderErrorMessage",
                errorMessage: undefined,
            });
        }

        if (state?.pages?.onePageCheckout?.placeOrderErrorMessage) {
            props.dispatch({
                type: "Pages/OnePageCheckout/SetPlaceOrderErrorMessage",
                errorMessage: undefined,
            });
        }
    },
);

addToChainAfter(chain, DispatchClearMessages, ClearCheckoutPlaceOrderErrorMessages);
